import "../Styles/About.css";


export const About = () => { 
 
  return (
    <div className="about" id="about">
      <p className="about-header">About Me!</p>
      <div className="about-content">
        <div className="text">
          <div>
            Hi My name is Aditya Kumar. A Full Stack Web Developer, Passionate
            about Information Technology. Excited to make the virtual world
            beautiful, efficient, and tempting. Proactive and fast learner,
            having excellent communication and teamwork skills. Eager to make a
            contribution to the industry using my Skillset, Toolset, and
            Mindset.
          </div>
          <br />
          <div>
            I have been passionate about new technologies since childhood. I
            always wanted to be in tech industry, but due to lack of guidance I
            chose Mechanical Engineering. Masai school gave me that second
            chance to fulfil my dreams. At masai I learnt MERN Stack, Data
            Structure and Algorithm along with Soft Skills.
          </div>
        </div>
        <div className="stats">
          <div className="stats-content">
            <h1>1200+</h1>
            <h3>HOURS OF CODING</h3>
          </div>
          <div className="stats-content">
            <h1>400+</h1>
            <h3>GIT COMMITS</h3>
          </div>
          <div className="stats-content">
            <h1>400+</h1>
            <h3>DSA PROBLEMS SOLVED</h3>
          </div>
          <div className="stats-content">
            <h1>100+</h1>
            <h3>HOURS OF SOFT SKILLS</h3>
          </div>
        </div>
        <img
          className="gitHub-img"
          src="https://ghchart.rshah.org/onlyaditya"
          alt="2016rshah's Github chart"
        />
       
      </div>
      
    </div>
  );
};
